import { PUBLIC_PAGE_PREFIX } from './Routes';

export const getIsPublicRoute = (): boolean => {
  return window.location.pathname.includes(`/${PUBLIC_PAGE_PREFIX}/`);
};
